var shake = 'fx_e395032e_uy1vpf0';

export { shake };
//# sourceMappingURL=animation.vanilla.mjs.map
